
import { Injectable } from '@angular/core';
import { CombeniaService } from "../services/CombeniaService/CombeniaService";
import { ThrowStmt } from '@angular/compiler';
import { UserType, UserModel, BS_TYPE } from '../models/UserModel';
import { ORDERBY } from '../constants/tables';
import { DatePipe } from '@angular/common';
import { uniq } from 'lodash/array'
import { arrayMax } from 'highcharts';
import { BrandModel } from './BrandModel';
import { BackendDataService } from '../services/backendDataService/backendDataService';
import { SERVICES } from '../constants/services';

@Injectable()
export class FilterModel {

  userDivisions: Array<any>;
  currentFilters: Array<any> = [];
  currentBrand: string;
  public quickSearchList: Array<any> = [];

  public constructor(
    public combenia: CombeniaService,
    private datePipe: DatePipe,
    private userModel: UserModel,
    private brandModel: BrandModel,
    public backend: BackendDataService
  ) {


  }


 
  getCatalogFilterSet() {
    //comune a molte pagine
    return this.userModel.currentDivision.derivedCanSeeTheme?
     [
      {
        id: 'blueLight',
        title: 'BLUE_LIGHT',
        type: 'checkbox',
        value: false
      },
      {
        id: 'filterTreD',
        title: 'FILTER_3D',
        type: 'checkbox',
        value: false
      },
      {
        id: 'onlyFiltered',
        title: 'ONLY_SEASONYEARS',
        type: 'checkbox',
        value: false
      },
      {
        id: 'seasonCodeAndYear',
        title: 'SEASON_YEARS',
        type: 'accordion',
        selected: [],
        options: [],
        children: ['conceptDescr']
      },
      {
        id: 'collectionCode',
        title: 'COLLECTION',
        type: 'accordion',
        selected: [],
        options: [],
        children: ['conceptDescr']
      },
      {
        id: 'theme',
        title: 'THEME',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'materialGroupCode',
        title: 'CATEGORY',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'genderCode',
        title: 'GENDER',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'fittingCode',
        title: 'FITTING',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'size',
        title: 'SIZE',
        subtitle: 'SIZE_TITLE',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'caliber',
        title: 'CALIBER',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'frontMainMatCode',
        title: 'MATERIAL',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'colorCode',
        title: 'COLORS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'features',
        title: 'FEATURES',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'fashionGrade',
        title: 'TIER',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'opticals',
        title: 'SYMBOLS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'conceptDescr',
        title: "CONCEPT",
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'shapeCode',
        title: 'SHAPE',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'lensMaterialCode',
        title: 'LENS MATERIALS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'phaseOut',
        title: 'FILTER_PHASE_OUT',
        type: 'checkbox',
        value: false
      }
    ] : [
      {
        id: 'blueLight',
        title: 'BLUE_LIGHT',
        type: 'checkbox',
        value: false
      },
      {
        id: 'filterTreD',
        title: 'FILTER_3D',
        type: 'checkbox',
        value: false
      },
      {
        id: 'onlyFiltered',
        title: 'ONLY_SEASONYEARS',
        type: 'checkbox',
        value: false
      },
      {
        id: 'seasonCodeAndYear',
        title: 'SEASON_YEARS',
        type: 'accordion',
        selected: [],
        options: [],
        children: ['conceptDescr']
      },
      {
        id: 'collectionCode',
        title: 'COLLECTION',
        type: 'accordion',
        selected: [],
        options: [],
        children: ['conceptDescr']
      },
      {
        id: 'materialGroupCode',
        title: 'CATEGORY',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'genderCode',
        title: 'GENDER',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'fittingCode',
        title: 'FITTING',
        type: 'accordion',
        selected: [],
        options: [],
      },
      {
        id: 'size',
        title: 'SIZE',
        subtitle: 'SIZE_TITLE',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'caliber',
        title: 'CALIBER',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'frontMainMatCode',
        title: 'MATERIAL',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'colorCode',
        title: 'COLORS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'features',
        title: 'FEATURES',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'fashionGrade',
        title: 'TIER',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'opticals',
        title: 'SYMBOLS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'conceptDescr',
        title: "CONCEPT",
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'shapeCode',
        title: 'SHAPE',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'lensMaterialCode',
        title: 'LENS MATERIALS',
        type: 'accordion',
        selected: [],
        options: []
      },
      {
        id: 'phaseOut',
        title: 'FILTER_PHASE_OUT',
        type: 'checkbox',
        value: false
      }
    ]
  }



  getUserDivisions(): Promise<any> {
    if (this.userDivisions)
      return new Promise((resolve, reject) => {
        resolve(this.userDivisions);
      });


    return this.combenia.readEntity("user_divisions", {
      action: "selectAllUserDivisions"
    }).then((data: any) => {
      this.userDivisions = data;
      return data;
    });
  }

  getFeatureFilter() {
    var filter = [{
      id: "hero",
      description: "HERO"
    }, {
      id: "adv",
      description: "ADV"
    }, {
      id: "limited_edition",
      description: "LIMITED EDITION"
    }, {
      id: "mke",
      description: "MKE"
    }, {
      id: "new",
      description: "NEW"
    }, {
      id: "blue_beyond",
      description: "BLUE & BEYOND"
    }]
    if (this.userModel.currentDivision.bestSellerType != BS_TYPE.NONE) {
      filter.push({
        id: "best_seller",
        description: this.userModel.currentDivision.bestSellerType == BS_TYPE.KPS ? "KPS" : "BEST_SELLER"
      })
    }

    return filter;

  }

  getOpticalsFilter() {
    var filter = [
      { 
        id: "progressive", 
        description: "IS_PROGRESSIVE" 
      }, { 
        id: "myopia", 
        description: "MYOPIA_FILT" 
      }, { 
        id: "easyAssembly", 
        description: "EASY_ASS" 
      }, {
        id: "flex",
        description: "FLEX_HINGE"
      }, { 
        id: "smartCurvy", 
        description: "SMART_TEMPLE" 
      }, { 
        id: "light", 
        description: "LIGHT_WEiGHT" 
      }, {
        id: "polarized",
        description: "POLARIZED_LENS"
      }, {
        id: "antiReflect",
        description: "ANTI_REFL"
      }, {
        id: "blueLight",
        description: "BL_REDUCTION"
      }, {
        id: "photocromatic",
        description: "POTHOC"
      }, {
        id: "convertible",
        description: "CONV_OPTICAL"
      }];
    return filter;
  }

  getDivisionsByCountry(country): Array<any> {
    return this.userModel.userDivisions.filter((d) => { return d.countryCode == country });
  }

  getSalesOrgs(): Promise<any> {
    return this.getUserDivisions().then((divs) => {
      let values = divs.map((d) => d.sales_org);

      values = values.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
      return values.sort();
    });
  }

  getDistrCh(): Promise<any> {
    return this.getUserDivisions().then((divs) => {
      let values = divs.map((d) => { return d.distr_ch });
      values = values.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      return values.sort();
    })
  }
  getCountry(): Array<any> {
    let countries = [];
    this.userModel.userDivisions.forEach((el) => {
      countries.push(el.countryCode);
    })
    countries = countries.filter((value, index, self) => {
      return self.indexOf(value) === index
    })
    return countries.sort();
  }

  filtersToModelFilter(filters: Array<any>, modelFilter: any) {
    filters.forEach((filter) => {
      if (filter.type === 'accordion') {
        if (filter.selected && filter.selected.length > 0) {
          modelFilter[filter.id] = [];
          filter.selected.forEach((el) => {
            modelFilter[filter.id].push(el.id);
          })
        } else {
          modelFilter[filter.id] = [];
        }
      } else if (filter.type === 'date' || filter.type === 'text') {
        if (filter.value && filter.value != '') {
          modelFilter[filter.id] = filter.value;
        } else {
          modelFilter[filter.id] = "";
        }
      } else if (filter.type === 'checkbox') {
        if (filter.value) {
          modelFilter[filter.id] = filter.value;
        } else {
          modelFilter[filter.id] = null;
        }
      }
    })

  }

  filtersToCriteria(filters: Array<any>, filterValue?: any): any {
    let criteria: any = {};

    if (filterValue) {
      if (filterValue.order_column) {
        criteria.order_column = filterValue.order_column;
        criteria.sort = filterValue.sort;
      }
      if (filterValue && filterValue.dateFrom !== '' && filterValue.dateTo !== '') {
        criteria.date_from = this.datePipe.transform(filterValue.dateFrom, 'dd/MM/yyyy');
        criteria.date_to = this.datePipe.transform(filterValue.dateTo, 'dd/MM/yyyy');
      }
      if (filterValue.offset) {
        criteria.limit = filterValue.limit;
        criteria.offset = filterValue.offset;
      }
      if (filterValue.page) {
        criteria.page = filterValue.page;
      }
      if (filterValue.group_dual) {
        criteria.group_dual = true;
      }
    }
    filters.forEach((filter) => {
      if (filter.selected && filter.selected.length) {
        //patch per i dual. Se raggruppo mando sempre i codici main
        if (filter.id = 'store' && filterValue && filterValue.group_dual) {
          var newSelected = [];
          filter.selected.forEach(function (sel) {
            var store = filter.value.find((st) => {
              return st.id == sel;
            })
            newSelected.push(store && store.main_store ? store.main_store : store.id);

          })
          filter.selected = newSelected;
        }


        criteria[filter.criteria] = filter.selected;
      }
    });
    return criteria;
  }


  getKeringBrands(filters: Array<any> = []): Promise<any> {
    let criteria = this.filtersToCriteria(filters);

    return this.combenia.readEntity("brands", criteria);
  }



  isFilterOn(filter, brandSet?) {
    var fields = filter.filter ? filter.filter : filter;
    var isOn = false;
    for (var key in fields) {
      if (key != 'salesOrg' && key != 'distrCh'
        && key != 'brands' && key != 'offset' && key != 'limit' && key != 'sort' && key != 'order_column'
        && key != 'country' && key != 'isMarketSelection' && key != 'countryCode' && key != 'username' && key != 'id' && key != 'selectionCode') {
        if (Array.isArray(fields[key]) && fields[key].length)
          isOn = true;
        else if (!Array.isArray(fields[key]) && fields[key])
          isOn = true;
      }
      else if (key == 'brands') {
        if (!brandSet && fields[key].length)
          isOn = true;
        if (brandSet && fields[key].length != brandSet.length)
          isOn = true;
      }

    }
    return isOn;
  }


  async onFilterChange(filterChanged, filtersAvailable) {
    if (filterChanged.children) {
      filtersAvailable.forEach(async (f) => {
        if (filterChanged.children.includes(f.id)) {
          f.selected = [];
          f.value = await this.getFilterValue(f.id, filtersAvailable);
        }
      })
    }
  }

  setCurrentFilters(filters) {
    this.currentFilters = filters;
  }

  onFilterMenuChange(data) {
    console.log("PASSo")
  }

  getFilterCollection(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].collection, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterMaterial(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].material, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterSeasonYears(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].seasonYear, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterColors(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].colors, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterSize(filters) {
    // filters.username = this.userModel.username;
    // return this.backend.request(SERVICES["FILTERS"].size, filters).then(async (data: Array<any>) => {
    //   return data;
    // }).catch((error) => {
    //   console.log(error);
    //   return null;
    // });
    var filter = [{
      id: "XS",
      description: "XS (≤ 122mm)"
    }, {
      id: "S",
      description: "S (122,1 mm – 128 mm)"
    }, {
      id: "M",
      description: "M (128,1 mm – 134 mm)"
    }, {
      id: "L",
      description: "L (134,1 mm – 137,9 mm)"
    }, {
      id: "XL",
      description: "XL (≥138 mm)"
    }]
    return filter;
  }

  getFilterCaliber(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].caliber, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterFamily(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].concept, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterShape(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].shape, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getLensMaterialCode(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].lensMaterial, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  getFilterTheme(filters) {
    filters.username = this.userModel.username;
    return this.backend.request(SERVICES["FILTERS"].theme, filters).then(async (data: Array<any>) => {
      return data;
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  async getFilterValue(filterId: string, filters?: any) {
    var res = await this._getFilterValue(filterId, filters)
    if (filterId != 'size' && filterId != 'opticals') {
      return res.sort((a, b) => {
        return a.description > b.description ? 1 : a.description < b.description ? -1 : 0;
      });
    } else {
      return res;
    }

  }





  async _getFilterValue(filterId: string, filters?: any) {
    let res: Array<any>;
    switch (filterId) {

      case 'brands':
        res = await this.brandModel.getBrandsFromApi()
        return res.map((o) => {
          return { id: o.code, description: o.name };
        });
      case 'client_brands':
        res = await this.brandModel.getBrandsFromApi(filters)
        return res.map((o) => {
          return { id: o.code, description: o.name };
        });
      case 'sales_org':
        res = await this.getSalesOrgs();
        return res.map((o) => {
          return { id: o, description: o };
        });
      case 'distr_ch':
        res = await this.getDistrCh();
        return res.map((o) => {
          return { id: o, description: o };
        });
      case 'country':
        res = await this.getCountry();
        return res.map((o) => {
          return { id: o, description: o };
        });
      case 'sales_org_dist':
        res = await this.getDivisionsByCountry(filters);
        return res.map((o) => {
          return { id: o.salesOrg + '-' + o.distrCh, description: o.salesOrg + ' / ' + o.distrCh };
        });
      case 'materialGroupCode':
        return [{ id: "MG-0001", description: "SUNGLASSES" }, { id: "MG-0002", description: "OPTICAL FRAME" }]
      case 'genderCode':
        return [{ id: "WOMAN", description: "WOMAN" }, { id: "MAN", description: "MAN" }, { id: "UNISEX", description: "UNISEX" }, { id: "KID", description: "KID" }]
      case 'fittingCode':
        return [{ id: "INTNL", description: "INTERNATIONAL" }, { id: "KOREA", description: "KOREAN" }, { id: "SMART", description: "ASIAN" }, { id: "JAPAN", description: "JAPAN" }];
      case 'features':
        return this.getFeatureFilter();
      case 'opticals':
        return this.getOpticalsFilter();
      case 'collectionCode':
        res = await this.getFilterCollection(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'frontMainMatCode':
        res = await this.getFilterMaterial(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'seasonCodeAndYear':
        res = await this.getFilterSeasonYears(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'size':
        return this.getFilterSize(filters);
      case 'caliber':
        res = await this.getFilterCaliber(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'conceptDescr':
        res = await this.getFilterFamily(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'shapeCode':
        res = await this.getFilterShape(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case 'colorCode':
        res = await this.getFilterColors(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
      case "fashionGrade":
        return [{ id: "Z1", description: "Z1" }, { id: "Z2", description: "Z2" }, { id: "Z3", description: "Z3" }]
      case 'lensMaterialCode':
        res = await this.getLensMaterialCode(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        })
      case 'theme':
        res = await this.getFilterTheme(filters);
        return res.map((o) => {
          return { id: o.key, description: o.value }
        });
        // return [{id: "prova", description: "prova"}];
    }
  }


  valuesToId(filterId: string, values: Array<any>) {
    return new Promise((resolve, reject) => {
      let response = [];
      this.getFilterValue(filterId).then(res => {
        values.forEach(item => {
          let tmp = res.find(elem => elem.description === item);
          if (tmp) {
            response.push(tmp.id);
          }
        });
      });

      setTimeout(() => {
        resolve(response);
      }, 1000);
    });
  }

}
